#import '../fragments/account-plan-fragment.graphql'

query GetInvoicePreview($input: InvoicePreviewInput!) {
    invoicePreview(input: $input) {
        nextInvoiceDisplay
        billingCycleDisplay
        dueText
        subtitleText
        plan {
            ...AccountPlanFragment
        }
        isModified
        userSuppliedCouponApplied
        couponError
    }
}
